// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { EnumSettingItemType } from '../../../../../com/MetaPattern/APP/MDA/User/EnumSettingItemType';
import { SettingGroup } from './SettingGroup';
import { UserSetting } from './UserSetting';
import { SelectGroup } from './SelectGroup';
/**
 * 设置项 实体类
 * 设置项
 */
export class SettingItem extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** Code : 采用有含义的编码，全局编码唯一 */
  private _code: string;

  /** 设置：Code */
  public get code() {
    return this._code;
  }

  /** 获取：Code */
  public set code(value: string) {
    this._code = value;
  }

  /** 数据类型 : 数据类型 */
  private _dataType: EnumSettingItemType;

  /** 设置：数据类型 */
  public get dataType() {
    return this._dataType;
  }

  /** 获取：数据类型 */
  public set dataType(value: EnumSettingItemType) {
    this._dataType = value;
  }

  /** 缺省值 : 缺省值，多选时为选项值之和 */
  private _defaultValue: string;

  /** 设置：缺省值 */
  public get defaultValue() {
    return this._defaultValue;
  }

  /** 获取：缺省值 */
  public set defaultValue(value: string) {
    this._defaultValue = value;
  }

  /** 校验正则表达式 : 校验正则表达式，为空则不做校验 */
  private _validateExpression: string;

  /** 设置：校验正则表达式 */
  public get validateExpression() {
    return this._validateExpression;
  }

  /** 获取：校验正则表达式 */
  public set validateExpression(value: string) {
    this._validateExpression = value;
  }

  /** 描述 : 描述 */
  private _description: string;

  /** 设置：描述 */
  public get description() {
    return this._description;
  }

  /** 获取：描述 */
  public set description(value: string) {
    this._description = value;
  }

  /** 设置应用 : 设置应用的类别，使用枚举EnumSettingApply的值之和 */
  private _settingApply: number;

  /** 设置：设置应用 */
  public get settingApply() {
    return this._settingApply;
  }

  /** 获取：设置应用 */
  public set settingApply(value: number) {
    this._settingApply = value;
  }

  /** 可定制 : 是否可由用户自行定制，不可定制则由系统指定 */
  private _isCustomizable: boolean;

  /** 设置：可定制 */
  public get isCustomizable() {
    return this._isCustomizable;
  }

  /** 获取：可定制 */
  public set isCustomizable(value: boolean) {
    this._isCustomizable = value;
  }

  /** 可修改 : false代表没有值可以新建，有值不可修改 */
  private _isModify: boolean;

  /** 设置：可修改 */
  public get isModify() {
    return this._isModify;
  }

  /** 获取：可修改 */
  public set isModify(value: boolean) {
    this._isModify = value;
  }

  /** 设置分组 的ID */
  private _settingGroup_ID: string;

  /** 获取：设置分组 的ID */
  public get settingGroup_ID() {
    return this._settingGroup_ID;
  }

  /** 设置：设置分组 的ID */
  public set settingGroup_ID(value: string) {
    this._settingGroup_ID = value;
  }

  /** 设置分组  */
  private _settingGroup: SettingGroup;

  /** 获取：设置分组  */
  public get settingGroup() {
    return this._settingGroup;
  }

  /** 设置：设置分组  */
  public set settingGroup(value: SettingGroup) {
    this._settingGroup = value;
    if (value !== null) {
      this.settingGroup_ID = value.id;
    } else {
      this.settingGroup_ID = '';
    }
  }

  /** 用户设置 */
  private _userSettings: Array<UserSetting>;

  /** 获取：用户设置 */
  public get userSettings() {
    return this._userSettings;
  }

  /** 设置：用户设置 */
  public set userSettings(value: Array<UserSetting>) {
    this._userSettings = value;
  }

  /** 选项组 的ID */
  private _selectGroup_ID: string;

  /** 获取：选项组 的ID */
  public get selectGroup_ID() {
    return this._selectGroup_ID;
  }

  /** 设置：选项组 的ID */
  public set selectGroup_ID(value: string) {
    this._selectGroup_ID = value;
  }

  /** 选项组  */
  private _selectGroup: SelectGroup;

  /** 获取：选项组  */
  public get selectGroup() {
    return this._selectGroup;
  }

  /** 设置：选项组  */
  public set selectGroup(value: SelectGroup) {
    this._selectGroup = value;
    if (value !== null) {
      this.selectGroup_ID = value.id;
    } else {
      this.selectGroup_ID = '';
    }
  }

  constructor() {
    super();
    this._name = '';
    this._code = '';
    this._dataType = EnumSettingItemType.Text;
    this._defaultValue = '';
    this._validateExpression = '';
    this._description = '';
    this._settingApply = 1;
    this._isCustomizable = false;
    this._isModify = false;
    this._settingGroup_ID = '';
    this._settingGroup = null;
    this._userSettings = new Array<UserSetting>();
    this._selectGroup_ID = '';
    this._selectGroup = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: SettingItem, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.code = element.code;
      this.dataType = element.dataType;
      this.defaultValue = element.defaultValue;
      this.validateExpression = element.validateExpression;
      this.description = element.description;
      this.settingApply = element.settingApply;
      this.isCustomizable = element.isCustomizable;
      this.isModify = element.isModify;
      this.settingGroup_ID = element.settingGroup_ID;
      if (hasReference && element.settingGroup !== null) {
        this.settingGroup = element.settingGroup;
      }
      this.selectGroup_ID = element.selectGroup_ID;
      if (hasReference && element.selectGroup !== null) {
        this.selectGroup = element.selectGroup;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.code = json.Code;
    this.dataType = json.DataType as EnumSettingItemType;
    this.defaultValue = json.DefaultValue;
    this.validateExpression = json.ValidateExpression;
    this.description = json.Description;
    this.settingApply = json.SettingApply;
    this.isCustomizable = json.IsCustomizable;
    this.isModify = json.IsModify;
    this.settingGroup_ID = json.SettingGroup_ID;
    // if (json.SettingGroup !== null) {
    //   this.settingGroup = SettingGroup.Create(json.SettingGroup);
    // }
    if (json.UserSettings && json.UserSettings.length > 0) {
      json.UserSettings.forEach((element: any) => {
        const userSetting = UserSetting.Create(element);
        // userSetting.settingItem = this;
        this.userSettings.push(userSetting);
      });
    }
    this.selectGroup_ID = json.SelectGroup_ID;
    // if (json.SelectGroup !== null) {
    //   this.selectGroup = SelectGroup.Create(json.SelectGroup);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Code = this.code;
    json.DataType = this.dataType;
    json.DefaultValue = this.defaultValue;
    json.ValidateExpression = this.validateExpression;
    json.Description = this.description;
    json.SettingApply = this.settingApply;
    json.IsCustomizable = this.isCustomizable;
    json.IsModify = this.isModify;
    json.SettingGroup_ID = this.settingGroup_ID;
    if (this.userSettings && this.userSettings.length > 0) {
      json.UserSettings = [];
      this.userSettings.forEach((element) => {
        json.UserSettings.push(element.toJson());
      });
    }
    json.SelectGroup_ID = this.selectGroup_ID;
  }

  static Create(json: any): SettingItem {
    const settingItem = new SettingItem();
    settingItem.Deserialize(json);
    settingItem.json = json;
    return settingItem;
  }
}
